export const DOSHA_QUIZ = {
  quiz_id: "healthion_dosha_v1",
  title: "Discover Your Ayurvedic Prakriti",
  questions: [
    {
      id: 1, category: "Physical Traits",
      question: "What best describes your natural body frame and weight tendency?",
      options: [
        { text: "Slender, thin bones, difficult to gain weight", dosha: "vata" },
        { text: "Medium, athletic/muscular build, stable weight", dosha: "pitta" },
        { text: "Broad, sturdy/heavy build, gains weight easily", dosha: "kapha" },
      ],
    },
    {
      id: 2, category: "Physical Traits",
      question: "How would you describe your natural skin texture?",
      options: [
        { text: "Dry, rough, thin, prone to cracking or flaking", dosha: "vata" },
        { text: "Warm, sensitive, oily T-zone, prone to redness or acne", dosha: "pitta" },
        { text: "Thick, smooth, cool, oily, well-hydrated", dosha: "kapha" },
      ],
    },
    {
      id: 3, category: "Physical Traits",
      question: "How is your hair naturally?",
      options: [
        { text: "Dry, brittle, coarse, frizzy, or curly", dosha: "vata" },
        { text: "Fine, silky, prone to premature greying or thinning", dosha: "pitta" },
        { text: "Thick, dense, lustrous, dark, strong roots", dosha: "kapha" },
      ],
    },
    {
      id: 4, category: "Physical Traits",
      question: "How does weather affect your comfort?",
      options: [
        { text: "Dislike cold, dry, and windy weather; love warmth", dosha: "vata" },
        { text: "Cannot tolerate excess heat or bright sun; prefer cool environments", dosha: "pitta" },
        { text: "Dislike cold, damp, or humid weather; prefer warm and dry", dosha: "kapha" },
      ],
    },
    {
      id: 5, category: "Digestion & Sleep",
      question: "How is your natural appetite and digestion?",
      options: [
        { text: "Irregular, unpredictable; prone to gas or bloating", dosha: "vata" },
        { text: "Strong, intense; irritable if meals are delayed; prone to acidity", dosha: "pitta" },
        { text: "Steady but slow; can skip meals easily; heavy feeling after eating", dosha: "kapha" },
      ],
    },
    {
      id: 6, category: "Digestion & Sleep",
      question: "What are your typical sleep patterns?",
      options: [
        { text: "Light, interrupted, easily disturbed by noise", dosha: "vata" },
        { text: "Moderate (6–7 hours), sound, wake up feeling alert", dosha: "pitta" },
        { text: "Heavy, deep, long (8+ hours); difficulty waking up", dosha: "kapha" },
      ],
    },
    {
      id: 7, category: "Mental & Behavioral Patterns",
      question: "How do you react when under extreme stress or pressure?",
      options: [
        { text: "Anxious, fearful, restless, overthinking", dosha: "vata" },
        { text: "Irritable, angry, impatient, critical", dosha: "pitta" },
        { text: "Withdrawn, calm, stubborn, resistant to change", dosha: "kapha" },
      ],
    },
    {
      id: 8, category: "Mental & Behavioral Patterns",
      question: "How do you learn and remember information?",
      options: [
        { text: "Learn very quickly, but forget just as fast", dosha: "vata" },
        { text: "Sharp, analytical memory; retains key facts clearly", dosha: "pitta" },
        { text: "Takes time to learn, but once learned, never forgotten", dosha: "kapha" },
      ],
    },
    {
      id: 9, category: "Mental & Behavioral Patterns",
      question: "What is your typical energy level throughout the day?",
      options: [
        { text: "Comes in sudden energetic bursts, followed by quick fatigue", dosha: "vata" },
        { text: "High, steady, goal-driven, and intense", dosha: "pitta" },
        { text: "Slow to start, but excellent long-term stamina", dosha: "kapha" },
      ],
    },
    {
      id: 10, category: "Mental & Behavioral Patterns",
      question: "What is your financial / spending behavior?",
      options: [
        { text: "Impulsive, spend freely on spontaneous items", dosha: "vata" },
        { text: "Planned, spend on quality, luxury, or purposeful tools", dosha: "pitta" },
        { text: "Saver by nature, cautious and deliberate with money", dosha: "kapha" },
      ],
    },
  ],
  results: {
    vata: {
      title: "Vata Dominant",
      elements: "Air + Ether",
      tagline: "The Creative & Energetic Force",
      description:
        "Your body type is governed by movement and agility. When balanced, you are vivacious and creative; when unbalanced, you may experience dry skin, restlessness, and digestive irregularity.",
      recommended_herbs: ["Ashwagandha", "Brahmi", "Shatavari", "Bala"],
      accent: "#3B82F6",
    },
    pitta: {
      title: "Pitta Dominant",
      elements: "Fire + Water",
      tagline: "The Transformative & Focused Force",
      description:
        "Your body type is governed by metabolism and heat. When balanced, you have sharp focus and strong digestion; when unbalanced, you may experience acidity, heat sensitivity, and skin breakouts.",
      recommended_herbs: ["Amla", "Neem", "Giloy", "Bhringraj", "Chandan"],
      accent: "#D97706",
    },
    kapha: {
      title: "Kapha Dominant",
      elements: "Earth + Water",
      tagline: "The Grounding & Nourishing Force",
      description:
        "Your body type is governed by structure and stamina. When balanced, you possess immense endurance and calm; when unbalanced, you may experience sluggish metabolism and lethargy.",
      recommended_herbs: ["Triphala", "Trikatu", "Tulsi", "Guggulu"],
      accent: "#059669",
    },
    tridoshic: {
      title: "Tridoshic",
      elements: "Balanced Harmony",
      tagline: "The Perfectly Balanced Constitution",
      description:
        "You possess an even distribution of Vata, Pitta, and Kapha energies, providing balanced immunity, stable metabolism, and emotional resilience.",
      recommended_herbs: ["Classical Chyawanprash", "Pure Shilajit", "Moringa"],
      accent: "#7C3AED",
    },
  },
};

export function computeDosha(answers) {
  // answers = ["vata","pitta",...] length 10
  const counts = { vata: 0, pitta: 0, kapha: 0 };
  answers.forEach((a) => { if (counts[a] !== undefined) counts[a] += 1; });
  const max = Math.max(counts.vata, counts.pitta, counts.kapha);
  const min = Math.min(counts.vata, counts.pitta, counts.kapha);
  // If very balanced (spread <= 2 and no dosha above 4), call it tridoshic
  if (max - min <= 1 && max <= 4) return { dominant: "tridoshic", counts };
  // Otherwise return the highest
  const dominant = Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0];
  return { dominant, counts };
}
